export default "__VITE_ASSET__QfuFzOTI__"